import React from 'react';
import StepTwoForm from './StepTwoForm';
import { withTranslation } from 'react-i18next';

const StepTwo = ({t}) => {
  return (
    <div className="w-full">
      <h1 className="text-4xl font-bold text-black mb-3">
        { t('registration.step_two.title') }
      </h1>
      <p className="text-secondary mb-8">
        { t('registration.step_two.content') }
      </p>
      <StepTwoForm />
    </div>
  )
}


export default withTranslation()(StepTwo)